import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RoomIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RoomIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.0936 2.31348C16.9982 2.31625 16.8747 2.35568 16.838 2.36986L16.8342 2.37124C16.7284 2.41517 16.6222 2.52966 16.5828 2.64069C16.5706 2.67355 16.5371 2.76313 16.5267 4.20825H10.3722C7.51651 4.20825 7.25675 4.22105 7.07654 4.29438C6.81712 4.40437 6.63519 4.57662 6.48715 4.85126L6.38165 5.04288L6.35986 21.6701L6.48646 21.9457C6.63485 22.2214 6.81678 22.3937 7.07897 22.505C7.23531 22.5687 7.45218 22.5863 9.39158 22.5863C9.67486 22.5863 9.9955 22.586 10.358 22.5853C10.8682 22.5853 16.7035 22.5829 16.8411 22.533C16.855 22.5292 16.884 22.533 16.9038 22.5417C17.1362 22.6444 17.4624 22.5095 17.5769 22.266C17.6606 22.0827 17.6606 2.82228 17.5765 2.63827C17.4956 2.46221 17.2652 2.31348 17.0936 2.31348ZM10.3483 5.32962C12.1296 5.32962 16.2514 5.331 16.4849 5.35867C16.5381 6.60421 16.5381 20.1959 16.4849 21.4397C16.2517 21.4674 12.13 21.4687 10.3483 21.4687C8.56663 21.4687 7.72888 21.4674 7.49575 21.4397C7.44248 20.1955 7.44248 6.60249 7.49575 5.35833C7.72888 5.331 8.56663 5.32962 10.3483 5.32962Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.10655 14.0367C9.24906 14.1093 9.37565 14.1456 9.50363 14.1456C9.63922 14.1456 9.77654 14.1048 9.93599 14.0235C10.2335 13.8775 10.4666 13.5126 10.4666 13.193C10.4666 12.9485 10.2774 12.5988 10.0636 12.4466C9.86335 12.2989 9.48322 12.2515 9.25528 12.3006C9.00555 12.3542 8.66174 12.7278 8.60985 13.0028C8.52926 13.441 8.71915 13.8371 9.10655 14.0367Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RoomIcon;
